export default __webpack_public_path__ + "static/media/22.98e49911.jpg";